import React from "react";
import closeIcon from "../assets/closeIcon.svg";

const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#000000] bg-opacity-70 backdrop-blur-sm">
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0062ff] bg-opacity-20 backdrop-blur-sm">
      {/* Modal Box */}
      <div className="bg-white rounded-lg shadow-lg w-full max-w-[700px] p-6 relative flex flex-col items-center justify-center text-center">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
        >
          <img width={24} src={closeIcon} alt="Close" />
        </button>

        {/* Modal Title */}
        {title && <h2 className="text-lg font-semibold mb-4">{title}</h2>}

        {/* Centered Content */}
        <div className="flex flex-col items-center justify-center w-full">
          {children}
        </div>
      </div>
    </div>
    </div>
  );
};

export default Modal;
